function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17,
  fill: "white",
  stroke: "#008C85"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 25.8332C17.5 25.8332 24.1667 22.4998 24.1667 17.4998V11.6665L17.5 9.1665L10.8334 11.6665V17.4998C10.8334 22.4998 17.5 25.8332 17.5 25.8332Z",
  fill: "#008C85",
  stroke: "#008C85",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgApprovedFullShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedFullShield);
export default __webpack_public_path__ + "static/media/Approved_Full_Shield.bb118adb50b15c446d32eecc5ea9d243.svg";
export { ForwardRef as ReactComponent };